<template>
  <div class="documentacao-servico-funerario">
    <div class="pagina-documentacao">
      <pulse-card
        title="Documentação"
        subtitle="Atendimentos funerários e emissão de documentos."
      >
        <div class="filtros-documentacao-grid">
          <pulse-field label="Data início">
            <pulse-date-picker
              v-model="filtros.dataInicio"
              :error-messages="erroDataInicio"
              @input="selecionarData('dataInicio', false)"
            />
          </pulse-field>
          <pulse-field label="Data fim">
            <pulse-date-picker
              v-model="filtros.dataFim"
              :error-messages="erroDataFim"
              @input="selecionarData('dataFim', true)"
            />
          </pulse-field>
          <pulse-button
            label="Buscar"
            icon="pi pi-search"
            class="filtros-documentacao-botao"
            :loading="carregandoBusca"
            :disabled="!filtrosValidos"
            @click="executarBusca"
          />
        </div>

        <pulse-message v-if="mensagemErroFiltros" severity="warn" class="mt-4">
          {{ mensagemErroFiltros }}
        </pulse-message>

        <pulse-message v-if="erroBusca" severity="error" class="mt-4">
          {{ erroBusca }}
        </pulse-message>

        <div class="tabela-toolbar">
          <span class="tabela-resumo">{{ resumoTabela }}</span>
          <pulse-input-text
            v-model.trim="buscaTabela"
            icon="pi pi-search"
            placeholder="Buscar..."
            clearable
            class="tabela-busca"
          />
        </div>

        <v-data-table
          :headers="headers"
          :items="atendimentosFiltrados"
          :loading="carregandoBusca"
          :items-per-page="15"
          :footer-props="footerProps"
          item-key="idAtendimento"
          loading-text="Carregando atendimentos..."
          class="pulse-table"
          no-data-text="Nenhum atendimento encontrado para o filtro informado."
          no-results-text="Nenhum resultado encontrado."
          sort-by="dataAtendimento"
          :sort-desc="true"
        >
          <template v-slot:item.dataAtendimento="{ item }">
            {{ formatDateTime(item.dataAtendimento) }}
          </template>

          <template v-slot:item.etapa="{ item }">
            <pulse-tag
              :color="item.etapa && item.etapa.cor ? item.etapa.cor : '#64748b'"
              :value="item.etapa && item.etapa.nome ? item.etapa.nome : 'Sem etapa'"
            />
          </template>

          <template v-slot:item.acao="{ item }">
            <pulse-button
              label="Documentos"
              icon="pi pi-download"
              outlined
              small
              @click="abrirModalDocumentos(item)"
            />
          </template>
        </v-data-table>
      </pulse-card>

      <v-row v-if="false" class="mb-4 filtros-documentacao" align="end">
        <v-col cols="12" sm="6" md="3">
          <v-menu
            v-model="menuDataInicio"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatDate(filtros.dataInicio)"
                v-bind="attrs"
                v-on="on"
                label="Data Início"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                dense
                hide-details
              />
            </template>
            <v-date-picker
              v-model="filtros.dataInicio"
              @input="menuDataInicio = false"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-menu
            v-model="menuDataFim"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatDate(filtros.dataFim)"
                v-bind="attrs"
                v-on="on"
                label="Data Fim"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                dense
                hide-details
              />
            </template>
            <v-date-picker
              v-model="filtros.dataFim"
              @input="menuDataFim = false"
            />
          </v-menu>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="3"
          class="d-flex align-end coluna-botao-filtro"
        >
          <v-btn
            color="primary"
            :loading="carregandoBusca"
            @click="executarBusca"
            block
            class="botao-filtro"
          >
            <v-icon left>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="false && erroBusca">
        <v-col cols="12">
          <v-alert type="error" dense outlined>
            {{ erroBusca }}
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="false">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="atendimentos"
            :loading="carregandoBusca"
            loading-text="Carregando atendimentos..."
            class="elevation-1"
            no-data-text="Nenhum atendimento encontrado para o filtro informado."
          >
            <template v-slot:item.dataAtendimento="{ item }">
              {{ formatDateTime(item.dataAtendimento) }}
            </template>

            <template v-slot:item.etapa="{ item }">
              <v-chip
                :color="item.etapa && item.etapa.cor ? item.etapa.cor : 'grey'"
                text-color="white"
                small
              >
                {{
                  item.etapa && item.etapa.nome ? item.etapa.nome : "Sem etapa"
                }}
              </v-chip>
            </template>

            <template v-slot:item.acao="{ item }">
              <v-btn color="primary" small @click="abrirModalDocumentos(item)">
                <v-icon left small>mdi-file-download</v-icon>
                Puxar Documentos
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="dialogDocumentos" max-width="760px" scrollable>
      <v-card v-if="atendimentoSelecionado" class="pulse-dialog">
        <pulse-dialog-header
          title="Documentos do atendimento"
          icon="pi pi-folder-open"
          :subtitle="`Atendimento #${atendimentoSelecionado.idAtendimento || '-'}`"
          @close="fecharModalDocumentos"
        />

        <v-card-text class="pulse-dialog__body">
          <div class="resumo-atendimento">
            <div class="resumo-secao-titulo">
              <i class="pi pi-info-circle" />
              Resumo do atendimento
            </div>

            <div class="resumo-grid">
              <div>
                <div class="resumo-label">Atendimento</div>
                <div class="resumo-value">
                  #{{ atendimentoSelecionado.idAtendimento || "-" }}
                </div>
              </div>

              <div>
                <div class="resumo-label">Contrato</div>
                <div class="resumo-value">
                  {{ atendimentoSelecionado.contrato || "-" }}
                </div>
              </div>

              <div class="resumo-grid__largo">
                <div class="resumo-label">Data atendimento</div>
                <div class="resumo-value">
                  {{ formatDateTime(atendimentoSelecionado.dataAtendimento) }}
                </div>
              </div>

              <div class="resumo-grid__largo">
                <div class="resumo-label">Cliente</div>
                <div class="resumo-value destaque">
                  {{ atendimentoSelecionado.cliente || "-" }}
                </div>
              </div>

              <div class="resumo-grid__largo">
                <div class="resumo-label">Falecido</div>
                <div class="resumo-value destaque">
                  {{ atendimentoSelecionado.nomeFalecido || "-" }}
                </div>
              </div>
            </div>
          </div>

          <div class="documentos-titulo">Selecione o documento</div>

          <v-radio-group v-model="documentoSelecionado" hide-details class="mt-0 pt-0">
            <div
              v-for="documento in documentosDisponiveis"
              :key="documento.tipo"
              class="documento-card"
              :class="{ 'documento-card--ativo': documentoSelecionado === documento.tipo }"
              @click="documentoSelecionado = documento.tipo"
            >
              <v-radio :value="documento.tipo" color="#6366f1" class="mt-0 mb-0" />

              <div class="min-width-0">
                <div class="documento-nome">{{ documento.nome }}</div>
                <div class="documento-descricao">{{ documento.descricao }}</div>
              </div>
            </div>
          </v-radio-group>
        </v-card-text>

        <div class="pulse-dialog__footer">
          <pulse-button
            label="Cancelar"
            severity="secondary"
            text
            @click="fecharModalDocumentos"
          />
          <pulse-button
            label="Gerar impressão"
            icon="pi pi-print"
            :loading="carregandoImpressao"
            :disabled="!documentoSelecionado"
            @click="executarImpressao"
          />
        </div>
      </v-card>
    </v-dialog>

    <div ref="areaImpressao" id="area-impressao" class="area-impressao">
      <template v-if="documentosImpressao.length">
        <template v-for="documento in documentosImpressao">
          <div
            v-if="
              documento.tipo === 'os_comentarios' ||
              documento.tipo === 'os_mensalidades'
            "
            :key="`${documento.tipo}-documento`"
            class="documento"
          >
            <div class="os-documento">
              <div class="os-titulo">
                DADOS DO ÓBITO Nº
                {{ campo(documento.dados, ["numeroOS", "idAtendimento"]) }}
              </div>

              <div class="os-observacao-principal">
                {{
                  documento.tipo === "os_mensalidades"
                    ? ""
                    : getTextoPrincipalOs(documento)
                }}
              </div>

              <div class="os-secao-titulo">OBSERVAÇÕES</div>

              <div class="os-grid">
                <div class="os-campo os-span-2">
                  <span>LOCAL SEPULTAMENTO DATA/HORA</span>
                  <strong>{{
                    campo(documento.dados, ["localSepultamento"])
                  }}</strong>
                  <strong>{{
                    formatDateTime(campo(documento.dados, ["dataSepultamento"]))
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>LOCAL VELÓRIO</span>
                  <strong>{{
                    campo(documento.dados, ["localVelorio"])
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>DATA/HORA</span>
                  <strong>{{
                    formatDateTime(campo(documento.dados, ["dataVelorio"]))
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>ALTURA</span>
                  <strong>{{
                    formatAltura(
                      campo(documento.dados, ["alturaFalecido", "altura"]),
                    )
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>DATA/HORA</span>
                  <strong>{{
                    formatDateTime(
                      campo(documento.dados, [
                        "dtFalecido",
                        "dataObito",
                        "dataFalecimento",
                      ]),
                    )
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>LOCAL RETIRADA</span>
                  <strong>{{
                    campo(documento.dados, ["origem", "localRetirada"])
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>PESO</span>
                  <strong>{{
                    formatPeso(campo(documento.dados, ["pesoFalecido", "peso"]))
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>LOCAL FALECIMENTO</span>
                  <strong>{{
                    campo(documento.dados, ["localFalecimento", "destino"])
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>FALECIDO</span>
                  <strong>{{
                    campo(documento.dados, ["nomeFalecido"])
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>RELIGIÃO</span>
                  <strong>{{ campo(documento.dados, ["religiao"]) }}</strong>
                </div>
                <div class="os-campo">
                  <span>CAUSA DA MORTE</span>
                  <strong>{{ campo(documento.dados, ["causaMorte"]) }}</strong>
                </div>
                <div class="os-campo">
                  <span>CAUSA PRINCIPAL</span>
                  <strong>{{
                    campo(documento.dados, ["causaPrincipal"])
                  }}</strong>
                </div>
              </div>

              <div class="os-secao-titulo">DADOS DO DECLARANTE</div>

              <div class="os-grid os-grid-declarante">
                <div class="os-campo">
                  <span>NOME</span>
                  <strong>{{
                    campo(documento.dados, ["declarante", "nomeDeclarante"])
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>PARENTESCO</span>
                  <strong>{{
                    campo(documento.dados, [
                      "parentescoDeclarante",
                      "parentesco",
                    ])
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>CPF</span>
                  <strong>{{
                    campo(documento.dados, ["cpfDeclarante", "cpfCliente"])
                  }}</strong>
                </div>
                <div class="os-campo">
                  <span>TELEFONE</span>
                  <strong>{{
                    campo(documento.dados, [
                      "contatoDeclarante",
                      "telefoneDeclarante",
                      "telefone",
                    ])
                  }}</strong>
                </div>
              </div>

              <div class="os-local-data">
                {{ campo(documento.dados, ["cidade", "localEmissao"]) }}/{{
                  campo(documento.dados, ["uf", "estado"])
                }},
                {{
                  formatDateExtenso(
                    campo(documento.dados, ["dataAtendimento", "dtFalecido"]),
                  )
                }}
              </div>

              <div
                v-if="documento.tipo === 'os_mensalidades'"
                class="os-mensalidades"
              >
                <div class="os-secao-titulo">MENSALIDADES</div>
                <div class="os-info-contrato">
                  <span
                    ><strong>Contrato:</strong>
                    {{ campo(documento.dados, ["contrato"]) || "-" }}</span
                  >
                  <span
                    ><strong>Vencimento:</strong>
                    {{
                      formatDate(campo(documento.dados, ["vencimento"]))
                    }}</span
                  >
                </div>

                <table class="os-tabela-mensalidades">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Quantidade</th>
                      <th>Valor Unitário</th>
                      <th>Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in getItensMensalidades(
                        documento.dados,
                      )"
                      :key="`os-mensalidade-${index}`"
                    >
                      <td>
                        {{
                          item.nome ||
                          item.nomeItem ||
                          item.descricao ||
                          "Mensalidade"
                        }}
                      </td>
                      <td>{{ item.quantidade || item.qtd || 1 }}</td>
                      <td>
                        {{
                          item.valorUnitario !== undefined
                            ? formatMoney(item.valorUnitario)
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          item.valorTotal !== undefined
                            ? formatMoney(item.valorTotal)
                            : "-"
                        }}
                      </td>
                    </tr>
                    <tr v-if="!getItensMensalidades(documento.dados).length">
                      <td colspan="4">Nenhuma mensalidade encontrada.</td>
                    </tr>
                  </tbody>
                </table>

                <p class="total-geral">
                  <strong>Total Geral:</strong>
                  {{
                    formatMoney(
                      campo(documento.dados, [
                        "valorTotalGeral",
                        "totalGeral",
                        "valorTotal",
                        "total",
                      ]),
                    )
                  }}
                </p>
              </div>

              <div v-else class="os-declaracoes">
                <p>
                  DECLARAÇÕES E INTERCORRÊNCIAS DA OS: (PREENCHER COM O NÚMERO
                  DO CONTRATO)
                </p>
                <p>
                  DECLARANTE:
                  {{ campo(documento.dados, ["declarante", "nomeDeclarante"]) }}
                </p>
                <p>
                  CPF:
                  {{ campo(documento.dados, ["cpfDeclarante", "cpfCliente"]) }}
                </p>
                <p>{{ getTextoDeclaracoesOs(documento) }}</p>
              </div>
            </div>
          </div>

          <div
            v-if="documento.tipo === 'ficha_controle'"
            :key="`${documento.tipo}-documento`"
            class="documento"
          >
            <div class="formulario-documento">
              <div class="qualidade-header fvs-header">
                <div class="qualidade-logo">
                  <img :src="logoGrupo" alt="Grupo Parque das Flores" />
                </div>
                <div class="qualidade-titulo">
                  <span>SISTEMA DE GESTÃO DA QUALIDADE</span>
                  <strong>FVS - FORMULÁRIO DE VERIFICAÇÃO DE SERVIÇO</strong>
                </div>
              </div>

              <table class="qualidade-meta">
                <tbody>
                  <tr>
                    <th>DOCUMENTO:</th>
                    <th>IDENTIFICAÇÃO:</th>
                    <th>REVISÃO:</th>
                    <th>FOLHA:</th>
                  </tr>
                  <tr>
                    <td>Formulário de Verificação de Serviço</td>
                    <td>FVS</td>
                    <td>01</td>
                    <td>1 / 1</td>
                  </tr>
                </tbody>
              </table>

              <div class="secao-form">1. IDENTIFICAÇÃO DO DECLARANTE / CONTATO</div>
              <div class="linha-campos tres">
                <div class="campo-linha">
                  <span>CONTATO:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "declarante",
                      "nomeDeclarante",
                      "cliente",
                      "nomeCliente",
                    ])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>PARENTESCO DO ÓBITO:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "parentescoDeclarante",
                      "parentesco",
                    ])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>FONE:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "contatoDeclarante",
                      "telefoneDeclarante",
                      "telefone",
                    ])
                  }}</strong>
                </div>
              </div>
              <div class="secao-form">2. DADOS DO FALECIDO</div>
              <div class="linha-campos linha-campos-local-retirada">
                <div class="campo-linha grande">
                  <span>FALECIDO:</span
                  ><strong>{{
                    campo(documento.dados, ["nomeFalecido"])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>DATA DO FALECIMENTO:</span
                  ><strong>{{
                    formatDate(
                      campo(documento.dados, [
                        "dtFalecido",
                        "dataObito",
                        "dataFalecimento",
                      ]),
                    )
                  }}</strong>
                </div>
                <div class="campo-linha pequeno">
                  <span>HORA:</span
                  ><strong>{{
                    formatTime(
                      campo(documento.dados, [
                        "dtFalecido",
                        "dataObito",
                        "dataFalecimento",
                      ]),
                    )
                  }}</strong>
                </div>
              </div>
              <div class="linha-campos linha-campos-endereco">
                <div class="campo-linha">
                  <span>CAUSA MORTIS:</span
                  ><strong>{{ campo(documento.dados, ["causaMorte"]) }}</strong>
                </div>
                <div class="campo-linha">
                  <span>CREDO:</span
                  ><strong>{{ campo(documento.dados, ["religiao"]) }}</strong>
                </div>
                <div class="campo-linha grande">
                  <span>LOCAL DE RETIRADA:</span
                  ><strong>{{
                    campo(documento.dados, ["origem", "localRetirada"])
                  }}</strong>
                </div>
              </div>
              <div class="secao-form">3. PROCEDIMENTOS REALIZADOS</div>
              <div class="linha-campos linha-campos-endereco">
                <div class="campo-linha full">
                  <span>AGENTES FUNERÁRIOS RESPONSÁVEIS PELO SERVIÇO:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "agentesFunerarios",
                      "agenteResponsavel",
                    ])
                  }}</strong>
                </div>
              </div>
              <div class="linha-campos tres">
                <div class="campo-linha">
                  <span>TAMPONAMENTO:</span
                  ><strong>{{
                    campo(documento.dados, ["tamponamento"])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>SOMATOCONSERVAÇÃO:</span
                  ><strong>{{
                    formatSimNao(
                      campo(documento.dados, ["usoSomatoConservacao"]),
                    )
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>ORNAMENTAÇÃO:</span
                  ><strong>{{
                    campo(documento.dados, ["ornamentacao"])
                  }}</strong>
                </div>
              </div>
              <div class="secao-form">4. VELÓRIO E SEPULTAMENTO</div>
              <div class="linha-campos dois">
                <div class="campo-linha">
                  <span>TRANSLADO PARA VELÓRIO:</span
                  ><strong>{{
                    campo(documento.dados, ["localVelorio"])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>TRANSLADO PARA SEPULTAMENTO:</span
                  ><strong>{{
                    campo(documento.dados, ["localSepultamento"])
                  }}</strong>
                </div>
              </div>

              <p class="texto-termo">
                AUTORIZAÇÃO: EU
                <strong>{{
                  campo(documento.dados, ["declarante", "nomeDeclarante"])
                }}</strong>
                CPF
                <strong>{{
                  campo(documento.dados, ["cpfDeclarante", "cpfCliente"])
                }}</strong>
              </p>
              <p class="texto-termo">
                AUTORIZO A RETIRADA:
                <span class="box"></span> TOTAL DE BARBA
                <span class="box"></span> PARCIAL DE BARBA
                <span class="box"></span> TOTAL DO BIGODE
                <span class="box"></span> NECROMAQUIAGEM
              </p>
              <p class="texto-termo">
                DO(A) FALECIDO(A)
                <strong>{{ campo(documento.dados, ["nomeFalecido"]) }}</strong>
                E AFIRMO TER SIDO ORIENTADO SOBRE OS PROCEDIMENTOS, AUTORIZANDO
                OS AGENTES A EXECUÇÃO DO MESMO, ISENTANDO O PREVIDA DE QUALQUER
                RESPONSABILIDADE.
              </p>
              <div class="linha-campos dois">
                <div class="campo-assinatura"><span>ASS:</span></div>
                <div class="campo-linha">
                  <span>Grau de Parentesco do Falecido:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "parentescoDeclarante",
                      "parentesco",
                    ])
                  }}</strong>
                </div>
              </div>

              <p class="texto-termo">
                LOCAL DO VELÓRIO:
                <span class="box"></span> CAPELA GPF Nº ____
                <span class="box"></span> IGREJA
                <span class="box"></span> CEMITÉRIO
                <span class="box"></span> RESIDÊNCIA
                <span class="box"></span> INTERIOR
                <span class="box"></span> IMEDIATO
              </p>
              <div class="linha-campos">
                <div class="campo-linha grande">
                  <span>ENDEREÇO:</span
                  ><strong>{{
                    campo(documento.dados, ["localVelorio"])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>CIDADE:</span
                  ><strong>{{ campo(documento.dados, ["cidade"]) }}</strong>
                </div>
                <div class="campo-linha pequeno">
                  <span>ESTADO:</span
                  ><strong>{{
                    campo(documento.dados, ["uf", "estado"])
                  }}</strong>
                </div>
              </div>
              <div class="linha-campos">
                <div class="campo-linha grande">
                  <span>SEPULTAMENTO: CEMITÉRIO</span
                  ><strong>{{
                    campo(documento.dados, ["localSepultamento"])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>DATA:</span
                  ><strong>{{
                    formatDate(campo(documento.dados, ["dataSepultamento"]))
                  }}</strong>
                </div>
                <div class="campo-linha pequeno">
                  <span>HORA:</span
                  ><strong>{{
                    formatTime(campo(documento.dados, ["dataSepultamento"]))
                  }}</strong>
                </div>
              </div>

              <div class="secao-form">5. TRANSPORTE DA FAMÍLIA</div>
              <p class="texto-termo">
                SOLICITAÇÃO TRANSPORTE FAMILIAR - CONFORME CONTRATO
                <span class="box"></span> SOLICITADO
                <span class="box"></span> DISPENSADO
                <span class="box"></span> NÃO DISPONIBILIZADO FORA DA ÁREA DE
                COBERTURA.
              </p>
              <div class="linha-campos">
                <div class="campo-linha">
                  <span>DATA:</span
                  ><strong>{{
                    formatDate(
                      campo(documento.dados, ["dataTransporteFamiliar"]),
                    )
                  }}</strong>
                </div>
                <div class="campo-linha pequeno">
                  <span>HORA:</span
                  ><strong>{{
                    formatTime(
                      campo(documento.dados, ["dataTransporteFamiliar"]),
                    )
                  }}</strong>
                </div>
                <div class="campo-linha grande">
                  <span>ENDEREÇO:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "origemTransporteFamiliar",
                      "destinoTransporteFamiliar",
                    ])
                  }}</strong>
                </div>
              </div>
              <div class="linha-campos dois">
                <div class="campo-linha">
                  <span>CLIENTE/RESPONSÁVEL:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "cliente",
                      "nomeCliente",
                      "declarante",
                    ])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>CPF:</span
                  ><strong>{{
                    campo(documento.dados, ["cpfCliente", "cpfDeclarante"])
                  }}</strong>
                </div>
              </div>
              <div class="linha-campos dois">
                <div class="campo-linha">
                  <span>MOTORISTA/AGENTE:</span
                  ><strong>{{
                    campo(documento.dados, ["motorista", "agenteResponsavel"])
                  }}</strong>
                </div>
                <div class="campo-linha pequeno">
                  <span>VTR:</span
                  ><strong>{{ campo(documento.dados, ["vtr"]) }}</strong>
                </div>
              </div>

              <div class="secao-form quebra-pagina">6. TERMOS E AUTORIZAÇÕES</div>
              <div class="subtitulo-form">
                TERMO DE DISPENSA DO SERVIÇO DE SOMATOCONSERVAÇÃO:
              </div>
              <p class="texto-termo">
                EU
                <strong>{{
                  campo(documento.dados, ["declarante", "nomeDeclarante"])
                }}</strong>
                CPF
                <strong>{{
                  campo(documento.dados, ["cpfDeclarante", "cpfCliente"])
                }}</strong>
                DECLARO PARA OS DEVIDOS FINS DE DIREITO QUE ESTOU CIENTE DA
                DISPENSA DO SERVIÇO DE SOMATOCONSERVAÇÃO E AFIRMO TER SIDO
                ORIENTADO(A) SOBRE NECESSIDADE DO PROCEDIMENTO E POSSÍVEIS
                ALTERAÇÕES QUE O CORPO VENHA APRESENTAR.
              </p>
              <div class="linha-campos dois">
                <div class="campo-assinatura"><span>ASS:</span></div>
                <div class="campo-linha pequeno">
                  <span>DATA:</span
                  ><strong>{{ formatDate(new Date()) }}</strong>
                </div>
              </div>

              <div class="subtitulo-form">
                TERMO DE RESPONSABILIDADE PARA REGISTRO DE ÓBITO:
              </div>
              <p class="texto-termo">
                EU
                <strong>{{
                  campo(documento.dados, ["declarante", "nomeDeclarante"])
                }}</strong>
                CPF
                <strong>{{
                  campo(documento.dados, ["cpfDeclarante", "cpfCliente"])
                }}</strong>
                ASSUMO TODA E QUALQUER RESPONSABILIDADE EM REGISTRAR O ÓBITO
                DO(A) SR(A)
                <strong>{{ campo(documento.dados, ["nomeFalecido"]) }}</strong
                >, AUTORIZANDO OS AGENTES A REALIZAREM A PREPARAÇÃO DO ÓBITO.
              </p>

              <div class="secao-form">7. VALIDAÇÃO E ASSINATURAS</div>
              <div class="subtitulo-form">VALIDAÇÃO DO SERVIÇO FUNERÁRIO:</div>
              <p class="texto-termo">
                DECLARO, PARA OS DEVIDOS FINS, QUE OS SERVIÇOS FUNERÁRIOS FORAM
                REALIZADOS DE ACORDO COM O PREVISTO NO PLANO CONTRATADO E
                CONFORME O REQUISITADO PELO(A) SOLICITANTE.
              </p>
              <div class="linha-campos">
                <div class="campo-linha full">
                  <span>AGENTE RESPONSÁVEL:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "agenteResponsavel",
                      "agentesFunerarios",
                    ])
                  }}</strong>
                </div>
              </div>
              <div class="campo-assinatura">
                <span>ASSINATURA DO FAMILIAR/RESPONSÁVEL:</span>
              </div>
              <div class="linha-final-form">
                LOCAL
                {{ campo(documento.dados, ["cidade", "localEmissao"]) }} DATA
                ____/____/_____
              </div>
            </div>
          </div>

          <div
            v-if="documento.tipo === 'termo_dispensa'"
            :key="`${documento.tipo}-documento`"
            class="documento"
          >
            <div class="ter-documento">
              <div class="qualidade-header">
                <div class="qualidade-logo">SISTEMA DE GESTÃO DA QUALIDADE</div>
                <div class="qualidade-titulo">TER - TERMO</div>
              </div>

              <table class="qualidade-meta">
                <tbody>
                  <tr>
                    <th>DOCUMENTO:</th>
                    <th>IDENTIFICAÇÃO:</th>
                    <th>REVISÃO:</th>
                    <th>FOLHA:</th>
                  </tr>
                  <tr>
                    <td>
                      Termo de Dispensa, Utilização e Recolhimento de Itens do
                      Serviço
                    </td>
                    <td>TER</td>
                    <td>03</td>
                    <td>1 / 1</td>
                  </tr>
                </tbody>
              </table>

              <div class="linha-campos dois">
                <div class="campo-linha">
                  <span>IDENTIFICAÇÃO DO FALECIDO:</span
                  ><strong>{{
                    campo(documento.dados, ["nomeFalecido"])
                  }}</strong>
                </div>
                <div class="campo-linha">
                  <span>Nº DO CONTRATO:</span
                  ><strong>{{ campo(documento.dados, ["contrato"]) }}</strong>
                </div>
              </div>

              <table class="tabela-termo-itens">
                <thead>
                  <tr>
                    <th></th>
                    <th>UTILIZADO</th>
                    <th>RECOLHIDO</th>
                    <th>DISPENSADO</th>
                    <th>OBSERVAÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in itensTermo" :key="item">
                    <td>{{ item }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <p class="nota-termo">*Itens exclusivos na Região Agreste</p>

              <p class="texto-termo">
                UTILIZAÇÃO: EU
                <strong>{{
                  campo(documento.dados, [
                    "declarante",
                    "nomeDeclarante",
                    "cliente",
                    "nomeCliente",
                  ])
                }}</strong>
                CPF
                <strong>{{
                  campo(documento.dados, ["cpfDeclarante", "cpfCliente"])
                }}</strong>
              </p>
              <p class="texto-termo">
                DECLARO TER RECEBIDO OS MATERIAIS DA COLUNA "UTILIZADO" EM
                PERFEITAS CONDIÇÕES DE USO, CIENTE QUE O RECOLHIMENTO DOS
                MATERIAIS SERÁ REALIZADO POR FUNCIONÁRIO DO PREVIDA DEVIDAMENTE
                FARDADO.
              </p>

              <p class="texto-termo">
                DISPENSA: EU
                <strong>{{
                  campo(documento.dados, [
                    "declarante",
                    "nomeDeclarante",
                    "cliente",
                    "nomeCliente",
                  ])
                }}</strong>
                CPF
                <strong>{{
                  campo(documento.dados, ["cpfDeclarante", "cpfCliente"])
                }}</strong>
              </p>
              <p class="texto-termo">
                DECLARO QUE TENHO CIÊNCIA DA PRESTAÇÃO DE SERVIÇO, CLÁUSULA 2ª
                QUE TRATA DOS SERVIÇOS A SEREM PRESTADOS PELA EMPRESA. MEDIANTE
                ISTO, SOLICITO A DISPENSA DO(S) ITEM(NS) RELACIONADOS NA COLUNA
                "DISPENSADO".
              </p>

              <div class="campo-assinatura triplo">
                <span>ASS:</span>
              </div>

              <div class="subtitulo-form">MONTAGEM DE VELÓRIO:</div>
              <div class="linha-campos dois">
                <div class="campo-linha">
                  <span>AGENTE:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "agenteMontagem",
                      "agenteResponsavel",
                    ])
                  }}</strong>
                </div>
                <div class="campo-linha pequeno">
                  <span>DATA:</span
                  ><strong>{{
                    formatDate(campo(documento.dados, ["dataVelorio"]))
                  }}</strong>
                </div>
              </div>

              <div class="subtitulo-form">DESMONTAGEM DE VELÓRIO:</div>
              <div class="linha-campos dois">
                <div class="campo-linha">
                  <span>AGENTE:</span
                  ><strong>{{
                    campo(documento.dados, [
                      "agenteDesmontagem",
                      "agenteResponsavel",
                    ])
                  }}</strong>
                </div>
                <div class="campo-linha pequeno">
                  <span>DATA:</span
                  ><strong>{{
                    formatDate(campo(documento.dados, ["dataSepultamento"]))
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import DocumentacaoService from "@/services/documentacaofuneraria";
import logoGrupo from "@/assets/logo_grupo.png";

export default {
  name: "DocumentacaoServicoFunerario",
  data() {
    return {
      logoGrupo,
      headers: [
        { text: "Atendimento", value: "idAtendimento" },
        { text: "Cliente", value: "cliente" },
        { text: "Falecido", value: "nomeFalecido" },
        { text: "Contrato", value: "contrato" },
        { text: "Data", value: "dataAtendimento" },
        { text: "Etapa", value: "etapa", sortable: false },
        { text: "Ação", value: "acao", sortable: false },
      ],
      atendimentos: [],
      buscaTabela: "",
      filtros: {
        dataInicio: "",
        dataFim: "",
      },
      menuDataInicio: false,
      menuDataFim: false,
      carregandoBusca: false,
      erroBusca: "",
      dialogDocumentos: false,
      atendimentoSelecionado: null,
      documentoSelecionado: null,
      documentosDisponiveis: [
        {
          tipo: "os_comentarios",
          nome: "OS (Com comentários)",
          descricao:
            "Ordem de serviço contendo comentários e observações registradas no atendimento.",
        },

        {
          tipo: "os_mensalidades",
          nome: "OS (Com mensalidades)",
          descricao:
            "Ordem de serviço com informações detalhadas das mensalidades vinculadas.",
        },

        {
          tipo: "ficha_controle",
          nome: "FVS - Ficha de Verificação de Serviço",
          descricao:
            "Documento utilizado para validação e acompanhamento da execução do serviço.",
        },

        {
          tipo: "termo_dispensa",
          nome: "Termo de Dispensa, Utilização e Recolhimento",
          descricao:
            "Termo formal relacionado à dispensa, utilização e recolhimento de materiais.",
        },
      ],
      itensTermo: [
        "URNA MORTUÁRIA: (Ref. E Fábrica)",
        "VEÍCULO FUNERÁRIO",
        "HIGIENIZAÇÃO",
        "VESTIMENTA SOCIAL E VÉU",
        "TAXA DE SEPULTAMENTO (Conf. Contrato)",
        "ORNAMENTAÇÃO DA URNA COM FLORES DO CAMPO E/OU MANTO",
        "COROA DE FLORES (Conf. Contrato)",
        "SOMATOCONSERVAÇÃO (Conf. Contrato)",
        "CHUVA DE PÉTALAS (Conf. Contrato)",
        "RITUAL DE DESPEDIDA",
        "ASSESSORIA CARTORIAL",
        "VELÓRIO ONLINE NA CENTRAL DE VELÓRIOS (Conf. Disponibilidade)",
        "VELÓRIO EM CAPELAS DO GPF (Conf. Contrato)",
        "PARAMENTOS",
        "RESPLENDOR CRISTO OU BÍBLIA + SUPORTE PARA URNA",
        "CASTIÇAIS + VELAS",
        "TAPETE",
        "CAPAS PARA PARAMENTOS + SUPORTE PARA COROA",
        "PANO DE FUNDO + SAIA PARA URNA",
        "TENDA. BANCOS E OU CADEIRAS*",
        "NOTA DE FALECIMENTO*",
        "ENFERMEIRA (Conf. Contrato)",
        "SANTINHOS FÍSICO E OU DIGITAL (Conf. Contrato)",
        "KIT RESIDÊNCIA",
        "01 PACOTE CAFÉ 250g + CHÁ, 50 UND. COPOS DESCARTÁVEIS 180ML",
        "02 PACOTES BOLACHAS + BISCOITOS DOCES",
        "01 BOTIJÃO DE ÁGUA 20L",
        "01 GELÁGUA",
        "01 CAFETEIRA*",
        "KIT VELÓRIO CAPELAS DO GPF",
      ],
      carregandoImpressao: false,
      erroImpressao: "",
      dadosImpressao: [],
      footerProps: {
        "items-per-page-options": [15, 30, 50, 100],
      },
    };
  },
  computed: {
    documentosImpressao() {
      return Array.isArray(this.dadosImpressao) ? this.dadosImpressao : [];
    },
    erroDataInicio() {
      if (!this.filtros.dataInicio) {
        return "Informe a data inicio";
      }

      return this.isDataInputValida(this.filtros.dataInicio)
        ? ""
        : "Data inicio invalida";
    },
    erroDataFim() {
      if (!this.filtros.dataFim) {
        return "Informe a data fim";
      }

      return this.isDataInputValida(this.filtros.dataFim)
        ? ""
        : "Data fim invalida";
    },
    filtrosValidos() {
      return !this.mensagemErroFiltros;
    },
    mensagemErroFiltros() {
      if (this.erroDataInicio) {
        return this.erroDataInicio;
      }

      if (this.erroDataFim) {
        return this.erroDataFim;
      }

      if (this.filtros.dataInicio > this.filtros.dataFim) {
        return "A data inicio nao pode ser maior que a data fim.";
      }

      return "";
    },
    atendimentosFiltrados() {
      if (!this.buscaTabela) {
        return this.atendimentos;
      }

      const buscaNormalizada = this.normalizarTexto(this.buscaTabela);

      return this.atendimentos.filter((item) => {
        const conteudo = [
          item.idAtendimento,
          item.cliente,
          item.nomeFalecido,
          item.contrato,
          item.etapa && item.etapa.nome,
          item.dataAtendimento && this.formatDateTime(item.dataAtendimento),
        ]
          .map((valor) => this.normalizarTexto(valor))
          .join(" ");

        return conteudo.includes(buscaNormalizada);
      });
    },
    resumoTabela() {
      const total = this.atendimentos.length;
      const filtrados = this.atendimentosFiltrados.length;

      if (!this.buscaTabela) {
        return `${total} atendimento(s) carregado(s).`;
      }

      return `${filtrados} de ${total} atendimento(s) exibido(s).`;
    },
  },
  mounted() {
    this.inicializarDatas();
    this.init();
  },
  methods: {
    async init() {
      await this.executarBusca();
    },
    resetarFiltros() {
      this.inicializarDatas();
      this.buscaTabela = "";
      this.erroBusca = "";
      this.menuDataInicio = false;
      this.menuDataFim = false;
    },
    selecionarData(campo, fecharMenuFim) {
      if (campo === "dataInicio") {
        this.menuDataInicio = false;
      } else {
        this.menuDataFim = false;
      }

      this.erroBusca = "";

      if (fecharMenuFim && this.filtros.dataInicio > this.filtros.dataFim) {
        this.erroBusca = "A data inicio nao pode ser maior que a data fim.";
      }
    },
    inicializarDatas() {
      const hoje = new Date();
      const inicio = new Date();
      inicio.setDate(hoje.getDate() - 30);

      this.filtros.dataFim = this.toInputDate(hoje);
      this.filtros.dataInicio = this.toInputDate(inicio);
    },
    isDataInputValida(value) {
      if (!value || typeof value !== "string") return false;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

      const data = new Date(`${value}T00:00:00`);
      return !Number.isNaN(data.getTime()) && this.toInputDate(data) === value;
    },
    normalizarTexto(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    toInputDate(date) {
      const ano = date.getFullYear();
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      const dia = String(date.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },
    formatDate(value) {
      if (!value) return "";
      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [ano, mes, dia] = value.split("-");
        return `${dia}/${mes}/${ano}`;
      }
      const data = new Date(value);
      if (Number.isNaN(data.getTime())) return value;
      return data.toLocaleDateString("pt-BR");
    },
    formatDateTime(value) {
      if (!value) return "-";
      const data = new Date(value);
      if (Number.isNaN(data.getTime())) return value;
      return data.toLocaleString("pt-BR");
    },
    formatTime(value) {
      if (!value) return "";
      const data = new Date(value);
      if (Number.isNaN(data.getTime())) return "";
      return data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatDateExtenso(value) {
      if (!value) return "____ de __________________ de ______";
      const data = new Date(value);
      if (Number.isNaN(data.getTime())) return value;
      return data.toLocaleDateString("pt-BR", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    formatSimNao(value) {
      if (
        value === true ||
        value === "true" ||
        value === "S" ||
        value === "SIM"
      )
        return "SIM";
      if (
        value === false ||
        value === "false" ||
        value === "N" ||
        value === "NAO" ||
        value === "NÃO"
      )
        return "NÃO";
      return value || "";
    },
    formatAltura(value) {
      if (!value) return "";
      const numero = Number(value);
      if (Number.isNaN(numero)) return value;
      return `${numero.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} m`;
    },
    formatPeso(value) {
      if (!value) return "";
      const numero = Number(value);
      if (Number.isNaN(numero)) return value;
      return `${numero.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} kg`;
    },
    formatMoney(value) {
      const numero = Number(value);
      if (Number.isNaN(numero)) return "R$ 0,00";
      return numero.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    getTextoPrincipalOs(documento) {
      if (!documento || !documento.dados) return "";

      if (documento.tipo === "os_mensalidades") {
        return this.getTextoMensalidadesOs(documento.dados);
      }

      return this.campo(documento.dados, ["observacoes", "obs", "comentarios"]);
    },
    getTextoDeclaracoesOs(documento) {
      if (!documento || !documento.dados) return "";

      return this.campo(documento.dados, [
        "declaracoes",
        "intercorrencias",
        "comentariosOs",
      ]);
    },
    getItensMensalidades(dados) {
      if (!dados) return [];
      const itens = this.primeiroValor(
        dados.itens,
        dados.mensalidades,
        dados.parcelas,
      );
      return Array.isArray(itens) ? itens : [];
    },
    campo(dados, nomes, fallback = "") {
      if (!dados || !Array.isArray(nomes)) return fallback;

      for (const nome of nomes) {
        const valor = dados[nome];
        if (valor !== undefined && valor !== null && valor !== "") {
          return valor;
        }
      }

      return fallback;
    },
    primeiroValor(...valores) {
      return (
        valores.find((valor) => {
          if (Array.isArray(valor)) return valor.length > 0;
          return valor !== undefined && valor !== null && valor !== "";
        }) || ""
      );
    },
    valorPreenchido(valor) {
      if (Array.isArray(valor)) return valor.length > 0;
      return valor !== undefined && valor !== null && valor !== "";
    },
    mesclarDadosPreenchidos(...fontes) {
      return fontes.reduce((acumulado, fonte) => {
        if (!fonte || typeof fonte !== "object") return acumulado;

        Object.keys(fonte).forEach((chave) => {
          const valor = fonte[chave];
          const valorPreenchido = this.valorPreenchido(valor);

          if (valorPreenchido || !this.valorPreenchido(acumulado[chave])) {
            acumulado[chave] = valor;
          }
        });

        return acumulado;
      }, {});
    },
    formatarListaNomes(lista) {
      if (!Array.isArray(lista)) return "";

      return lista
        .map((item) => {
          if (item && typeof item === "object") {
            return item.nome || item.name || item.descricao || item.id || "";
          }

          return item;
        })
        .filter(Boolean)
        .join(", ");
    },
    getEtapaPorId(dados, etapaId) {
      if (!dados || !Array.isArray(dados.etapas)) return null;
      return (
        dados.etapas.find(
          (etapa) => etapa.etapaId === etapaId || etapa.id === etapaId,
        ) || null
      );
    },
    getEtapaPorNome(dados, nomeEtapa) {
      if (!dados || !Array.isArray(dados.etapas) || !nomeEtapa) return null;
      const nomeNormalizado = nomeEtapa.toString().toLowerCase();

      return (
        dados.etapas.find((etapa) => {
          const nome = (etapa.nome || etapa.etapaNome || etapa.descricao || "")
            .toString()
            .toLowerCase();
          return nome.includes(nomeNormalizado);
        }) || null
      );
    },
    getServicoFunerarioId() {
      if (!this.atendimentoSelecionado) return null;

      return this.primeiroValor(
        this.atendimentoSelecionado.idAtendimento,
        this.atendimentoSelecionado.ticketId,
        this.atendimentoSelecionado.idTicket,
        this.atendimentoSelecionado.servicoFunerarioId,
      );
    },
    async carregarDadosServicoCompleto() {
      const id = this.getServicoFunerarioId();
      if (id) {
        try {
          const { data } =
            await DocumentacaoService.buscarServicoFunerarioPorId(id);

          return data || {};
        } catch (error) {
          console.warn(
            "Não foi possível carregar os dados completos do serviço funerário.",
            error,
          );
        }
      }

      return this.carregarDadosServicoCompletoPorAtendimento();
    },
    async carregarDadosServicoCompletoPorAtendimento() {
      const idAtendimento =
        this.atendimentoSelecionado &&
        this.atendimentoSelecionado.idAtendimento;

      if (!idAtendimento) return {};

      try {
        const { data } = await DocumentacaoService.listarServicosFunerarios(
          this.filtros.dataInicio,
          this.filtros.dataFim,
        );
        const servicos = Array.isArray(data) ? data : [];

        return (
          servicos.find(
            (servico) =>
              String(servico.idAtendimento) === String(idAtendimento),
          ) || {}
        );
      } catch (error) {
        try {
          previewWindow.close();
        } catch (closeError) {
          console.warn(
            "Nao foi possivel fechar a janela de pre-visualizacao.",
            closeError,
          );
        }
        console.warn(
          "Não foi possível localizar o serviço funerário pelo atendimento.",
          error,
        );
        return {};
      }
    },
    normalizarDadosDocumento(dadosDocumento, dadosServico = {}) {
      const dados = this.mesclarDadosPreenchidos(
        this.atendimentoSelecionado || {},
        dadosServico || {},
        dadosDocumento || {},
      );

      const etapaRemocao =
        this.getEtapaPorNome(dados, "remo") || this.getEtapaPorId(dados, 2);
      const etapaPreparacao =
        this.getEtapaPorNome(dados, "prepara") || this.getEtapaPorId(dados, 9);
      const etapaVelorio =
        this.getEtapaPorNome(dados, "vel") || this.getEtapaPorId(dados, 5);
      const etapaSepultamento =
        this.getEtapaPorNome(dados, "sepult") || this.getEtapaPorId(dados, 7);
      const etapaTransporte =
        this.getEtapaPorNome(dados, "transporte") ||
        this.getEtapaPorId(dados, 6);
      const etapas = [
        etapaRemocao,
        etapaPreparacao,
        etapaVelorio,
        etapaSepultamento,
        etapaTransporte,
      ].filter(Boolean);

      const colaboradoresEtapas = etapas
        .map((etapa) => this.formatarListaNomes(etapa.colaboradores))
        .filter(Boolean);
      const observacoesEtapas = (
        Array.isArray(dados.etapas) ? dados.etapas : []
      )
        .map((etapa) => etapa.observacoes || etapa.ocorrenciaJustificativa)
        .filter(Boolean);

      return Object.assign({}, dados, {
        idAtendimento: this.primeiroValor(
          dados.idAtendimento,
          dados.numeroOS,
          dados.atendimento,
        ),
        numeroOS: this.primeiroValor(
          dados.numeroOS,
          dados.idAtendimento,
          dados.atendimento,
        ),
        nomeCliente: this.primeiroValor(dados.nomeCliente, dados.cliente),
        cliente: this.primeiroValor(dados.cliente, dados.nomeCliente),
        nomeFalecido: this.primeiroValor(dados.nomeFalecido, dados.falecido),
        dataObito: this.primeiroValor(
          dados.dataObito,
          dados.dtFalecido,
          dados.dataFalecimento,
        ),
        dataFalecimento: this.primeiroValor(
          dados.dataFalecimento,
          dados.dtFalecido,
          dados.dataObito,
        ),
        localRetirada: this.primeiroValor(dados.localRetirada, dados.origem),
        localFalecimento: this.primeiroValor(
          dados.localFalecimento,
          dados.destino,
        ),
        agentesFunerarios: this.primeiroValor(
          dados.agentesFunerarios,
          dados.agenteResponsavel,
          colaboradoresEtapas.join(", "),
        ),
        agenteResponsavel: this.primeiroValor(
          dados.agenteResponsavel,
          dados.atendente,
          colaboradoresEtapas[0],
          this.formatarListaNomes(dados.colaboradoresSomato),
        ),
        observacoes: this.primeiroValor(
          dados.observacoes,
          dados.obs,
          dados.comentarios,
          observacoesEtapas.join("\n"),
        ),
        comentariosOs: this.primeiroValor(
          dados.comentariosOs,
          dados.intercorrencias,
          dados.declaracoes,
          observacoesEtapas.join("\n"),
        ),
        vtr: this.primeiroValor(
          dados.vtr,
          etapaRemocao && etapaRemocao.vtr,
          etapaTransporte && etapaTransporte.vtr,
        ),
        salaPreparacao: this.primeiroValor(
          dados.salaPreparacao,
          etapaPreparacao && etapaPreparacao.salaPreparacao,
        ),
        dataTransporteFamiliar: this.primeiroValor(
          dados.dataTransporteFamiliar,
          etapaTransporte && etapaTransporte.dtInicio,
        ),
        dataInicioSomato: this.primeiroValor(
          dados.dataInicioSomato,
          etapaPreparacao && etapaPreparacao.dtInicio,
        ),
        dataFimSomato: this.primeiroValor(
          dados.dataFimSomato,
          etapaPreparacao && etapaPreparacao.dtFim,
        ),
        dataVelorio: this.primeiroValor(
          dados.dataVelorio,
          etapaVelorio && etapaVelorio.dtInicio,
        ),
        dataSepultamento: this.primeiroValor(
          dados.dataSepultamento,
          etapaSepultamento && etapaSepultamento.dtInicio,
        ),
        origemTransporteFamiliar: this.primeiroValor(
          dados.origemTransporteFamiliar,
          dados.origem,
        ),
        destinoTransporteFamiliar: this.primeiroValor(
          dados.destinoTransporteFamiliar,
          dados.destino,
        ),
        ornamentacao: this.primeiroValor(
          dados.ornamentacao,
          this.getNomeItemPorTermo(dados.itens, "ornament"),
        ),
        tamponamento: this.primeiroValor(
          dados.tamponamento,
          this.getNomeItemPorTermo(dados.itens, "tampon"),
        ),
        itens: this.primeiroValor(
          dados.itens,
          dados.mensalidades,
          dados.parcelas,
        ),
        valorTotalGeral: this.primeiroValor(
          dados.valorTotalGeral,
          dados.totalGeral,
          dados.valorTotal,
          dados.total,
        ),
        cidade: this.primeiroValor(dados.cidade, dados.localidade, "Maceió"),
        uf: this.primeiroValor(dados.uf, dados.estado, "AL"),
      });
    },
    getNomeItemPorTermo(itens, termo) {
      if (!Array.isArray(itens) || !termo) return "";

      const termoNormalizado = termo.toString().toLowerCase();
      const item = itens.find((registro) => {
        const nome = (
          registro.nome ||
          registro.nomeItem ||
          registro.descricao ||
          ""
        )
          .toString()
          .toLowerCase();
        return nome.includes(termoNormalizado);
      });

      if (!item) return "";
      return item.nome || item.nomeItem || item.descricao || "";
    },
    getTipoDocumentoId(tipo) {
      const mapa = {
        os_comentarios: 1,
        os_mensalidades: 2,
        ficha_controle: 3,
        termo_dispensa: 4,
      };
      return mapa[tipo] || null;
    },
    async executarBusca() {
      if (!this.filtrosValidos) {
        this.erroBusca = this.mensagemErroFiltros;
        return;
      }

      this.atendimentos = [];
      this.carregandoBusca = true;
      this.erroBusca = "";

      try {
        const { data } = await DocumentacaoService.listarAtendimentos(
          this.filtros.dataInicio,
          this.filtros.dataFim,
        );
        if (data) {
          this.atendimentos = Array.isArray(data) ? data : [];
        }
      } catch (error) {
        console.error(error);
        this.atendimentos = [];
        this.erroBusca = this.getMensagemErro(
          error,
          "Não foi possível buscar os atendimentos.",
        );
      } finally {
        this.carregandoBusca = false;
      }
    },
    abrirModalDocumentos(item) {
      this.atendimentoSelecionado = item;
      this.limparDocumentosSelecionados();
      this.dadosImpressao = [];
      this.erroImpressao = "";
      this.dialogDocumentos = true;
    },
    fecharModalDocumentos() {
      this.dialogDocumentos = false;
      this.atendimentoSelecionado = null;
      this.limparDocumentosSelecionados();
      this.dadosImpressao = [];
      this.erroImpressao = "";
    },
    selecionarTodosDocumentos() {
      this.documentosSelecionados = this.documentosDisponiveis.map(
        (documento) => documento.tipo,
      );
    },
    limparDocumentosSelecionados() {
      this.documentosSelecionados = [];
    },
    async executarImpressao() {
      if (!this.documentoSelecionado || !this.atendimentoSelecionado) {
        return;
      }

      this.carregandoImpressao = true;
      this.erroImpressao = "";

      try {
        const dadosServico = await this.carregarDadosServicoCompleto();
        const tipoDocumentoId = this.getTipoDocumentoId(
          this.documentoSelecionado,
        );
        const { data } = await DocumentacaoService.buscarDocumentoAtendimento(
          this.atendimentoSelecionado.idAtendimento,
          tipoDocumentoId,
        );

        this.dadosImpressao = [
          {
            tipo: this.documentoSelecionado,
            dados: this.normalizarDadosDocumento(data, dadosServico),
          },
        ];

        this.dialogDocumentos = false;

        this.$nextTick(() => {
          this.imprimirDocumentosSelecionados();
        });
      } catch (error) {
        this.erroImpressao = this.getMensagemErro(
          error,
          "Nao foi possivel carregar o documento.",
        );
      } finally {
        this.carregandoImpressao = false;
      }
    },
    imprimirDocumentosSelecionados() {
      const areaImpressao = this.$refs.areaImpressao;

      if (!areaImpressao || !areaImpressao.innerHTML.trim()) {
        this.erroImpressao = "Nenhum documento disponivel para impressao.";
        this.dialogDocumentos = true;
        return;
      }

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";

      document.body.appendChild(iframe);

      const iframeWindow = iframe.contentWindow;
      const iframeDocument = iframe.contentDocument || iframeWindow.document;

      iframeDocument.open();
      iframeDocument.write(this.getHtmlImpressao(areaImpressao.innerHTML));
      iframeDocument.close();

      setTimeout(() => {
        const removerIframe = () => {
          if (iframe.parentNode) {
            document.body.removeChild(iframe);
          }
        };

        iframeWindow.onafterprint = removerIframe;
        iframeWindow.focus();
        iframeWindow.print();

        setTimeout(removerIframe, 60000);
      }, 100);
    },
    getHtmlImpressao(conteudo) {
      return `
                <!doctype html>
                <html lang="pt-BR">
                    <head>
                        <meta charset="utf-8">
                        <title>Documentos do Servico Funerario</title>
                        <style>
                            ${this.getCssImpressao()}
                        </style>
                    </head>
                    <body>
                        ${conteudo}
                    </body>
                </html>
            `;
    },
    getCssImpressao() {
      return `
                @page {
                    size: Letter portrait;
                    margin: 13mm 14mm;
                }

                * {
                    box-sizing: border-box;
                }

                body {
                    margin: 0;
                    font-family: Arial, sans-serif;
                    color: #000;
                    background: #fff;
                }

                .documento {
                    min-height: 253mm;
                    padding: 0;
                    page-break-after: always;
                    break-after: page;
                }

                .documento:last-child {
                    page-break-after: auto;
                    break-after: auto;
                }

                .os-documento,
                .formulario-documento,
                .ter-documento {
                    width: 100%;
                    font-size: 10px;
                    line-height: 1.25;
                }

                .os-titulo {
                    font-size: 18px;
                    font-weight: 700;
                    text-align: left;
                    margin-bottom: 8px;
                }

                .os-observacao-principal {
                    min-height: 42px;
                    border-bottom: 1px solid #000;
                    font-size: 11px;
                    font-weight: 700;
                    padding-bottom: 6px;
                    white-space: pre-wrap;
                }

                .os-secao-titulo {
                    font-size: 13px;
                    font-weight: 700;
                    text-align: center;
                    margin: 12px 0 8px;
                }

                .os-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    column-gap: 12px;
                    row-gap: 4px;
                }

                .os-grid-declarante {
                    margin-top: 8px;
                }

                .os-campo {
                    display: grid;
                    grid-template-columns: 105px 1fr;
                    gap: 4px;
                    align-items: end;
                    min-height: 18px;
                }

                .os-campo span {
                    font-size: 9px;
                    font-weight: 700;
                }

                .os-campo strong {
                    display: block;
                    min-height: 14px;
                    border-bottom: 1px solid #000;
                    font-size: 10px;
                    font-weight: 400;
                    word-break: break-word;
                }

                .os-span-2 {
                    grid-column: span 2;
                    grid-template-columns: 170px 1fr 150px;
                }

                .os-local-data {
                    margin-top: 22px;
                    text-align: right;
                    font-size: 11px;
                }

                .os-declaracoes {
                    margin-top: 22px;
                    font-size: 11px;
                    line-height: 1.45;
                    white-space: pre-wrap;
                }

                .os-declaracoes p {
                    margin: 4px 0;
                }

                .os-mensalidades {
                    margin-top: 22px;
                }

                .os-info-contrato {
                    display: flex;
                    justify-content: space-between;
                    gap: 12px;
                    margin-bottom: 8px;
                    font-size: 10px;
                }

                .os-tabela-mensalidades {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 6px;
                }

                .os-tabela-mensalidades th,
                .os-tabela-mensalidades td {
                    border: 1px solid #000;
                    padding: 5px;
                    font-size: 9px;
                    text-align: left;
                }

                .os-tabela-mensalidades th {
                    font-weight: 700;
                    background: #f2f2f2;
                }

                .qualidade-header {
                    border: 1px solid #000;
                    display: grid;
                    grid-template-columns: 38% 62%;
                    min-height: 34px;
                    align-items: center;
                    text-align: center;
                    font-weight: 700;
                }

                .qualidade-logo {
                    border-right: 1px solid #000;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 4px;
                }

                .qualidade-titulo {
                    padding: 4px;
                    font-size: 12px;
                }

                .qualidade-meta,
                .tabela-termo-itens {
                    width: 100%;
                    border-collapse: collapse;
                }

                .qualidade-meta {
                    margin-bottom: 14px;
                }

                .qualidade-meta th,
                .qualidade-meta td {
                    border: 1px solid #000;
                    padding: 3px 5px;
                    font-size: 9px;
                    text-align: left;
                }

                .qualidade-meta th {
                    font-weight: 700;
                }

                .linha-campos {
                    display: grid;
                    grid-template-columns: 1fr 150px 70px;
                    gap: 8px;
                    margin-bottom: 8px;
                    align-items: end;
                }

                .linha-campos.dois {
                    grid-template-columns: 1fr 1fr;
                }

                .linha-campos.tres {
                    grid-template-columns: repeat(3, 1fr);
                }

                .linha-campos-local-retirada {
                    grid-template-columns: minmax(0, 1.4fr) minmax(140px, 0.8fr) minmax(260px, 1.4fr);
                }

                .linha-campos-endereco {
                    grid-template-columns: minmax(0, 1.6fr) minmax(120px, 0.7fr) minmax(90px, 0.4fr);
                }

                .campo-linha {
                    display: flex;
                    align-items: flex-end;
                    gap: 4px;
                    min-width: 0;
                }

                .campo-linha.full {
                    grid-column: 1 / -1;
                }

                .campo-linha.grande {
                    min-width: 0;
                }

                .campo-linha.pequeno {
                    min-width: 70px;
                }

                .campo-linha span,
                .campo-assinatura span {
                    font-weight: 700;
                    white-space: nowrap;
                }

                .campo-linha strong {
                    border-bottom: 1px solid #000;
                    min-height: 14px;
                    flex: 1;
                    font-weight: 400;
                    word-break: break-word;
                    overflow-wrap: anywhere;
                }

                .campo-assinatura {
                    border-bottom: 1px solid #000;
                    min-height: 22px;
                    display: flex;
                    align-items: flex-end;
                    gap: 4px;
                    margin-bottom: 8px;
                }

                .campo-assinatura.triplo {
                    min-height: 28px;
                    margin: 16px 0;
                }

                .texto-termo {
                    margin: 7px 0;
                    font-size: 9.5px;
                    text-align: justify;
                }

                .texto-termo strong {
                    display: inline-block;
                    min-width: 130px;
                    border-bottom: 1px solid #000;
                    font-weight: 400;
                }

                .box {
                    display: inline-block;
                    width: 10px;
                    height: 10px;
                    border: 1px solid #000;
                    margin: 0 3px 0 8px;
                    vertical-align: middle;
                }

                .subtitulo-form {
                    font-weight: 700;
                    margin: 10px 0 5px;
                    font-size: 10px;
                }

                .linha-final-form {
                    margin-top: 12px;
                    text-align: center;
                    font-size: 10px;
                }

                .tabela-termo-itens {
                    margin: 10px 0 6px;
                }

                .tabela-termo-itens th,
                .tabela-termo-itens td {
                    border: 1px solid #000;
                    padding: 2px 4px;
                    font-size: 8px;
                    line-height: 1.1;
                }

                .tabela-termo-itens th {
                    text-align: center;
                    font-weight: 700;
                }

                .tabela-termo-itens td:first-child {
                    width: 55%;
                    font-weight: 700;
                }

                .tabela-termo-itens th:not(:first-child),
                .tabela-termo-itens td:not(:first-child) {
                    width: 11%;
                    height: 14px;
                }

                .nota-termo {
                    margin: 5px 0 8px;
                    font-size: 8px;
                }

                .cabecalho-impressao {
                    border-bottom: 2px solid #333;
                    padding-bottom: 15px;
                    margin-bottom: 20px;
                }

                .cabecalho-impressao h2 {
                    margin: 0 0 10px 0;
                    font-size: 18px;
                }

                .cabecalho-impressao p,
                .conteudo-impressao,
                .tabela-impressao th,
                .tabela-impressao td {
                    font-size: 12px;
                }

                .cabecalho-impressao p,
                .conteudo-impressao p {
                    margin: 5px 0;
                }

                .conteudo-impressao h3 {
                    margin: 15px 0 10px 0;
                    font-size: 14px;
                    border-bottom: 1px solid #ccc;
                    padding-bottom: 5px;
                }

                .checklist-impressao {
                    margin: 0;
                    padding-left: 18px;
                }

                .tabela-impressao {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 10px 0;
                }

                .tabela-impressao th,
                .tabela-impressao td {
                    border: 1px solid #ddd;
                    padding: 8px;
                    text-align: left;
                }

                .tabela-impressao th {
                    background-color: #f2f2f2;
                    font-weight: bold;
                }

                .total-geral {
                    margin-top: 16px;
                    text-align: right;
                }

                /* Identidade visual do FVS inspirada no modelo institucional. */
                .formulario-documento {
                    color: #111;
                    font-size: 9px;
                    line-height: 1.2;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }

                .fvs-header {
                    grid-template-columns: 155px 1fr;
                    min-height: 76px;
                    margin: 0;
                }

                .fvs-header .qualidade-logo {
                    padding: 5px 12px;
                    overflow: hidden;
                }

                .fvs-header .qualidade-logo img {
                    display: block;
                    width: 100%;
                    height: 62px;
                    object-fit: contain;
                }

                .fvs-header .qualidade-titulo {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 3px;
                    font-size: 14px;
                    line-height: 1.15;
                }

                .fvs-header .qualidade-titulo span,
                .fvs-header .qualidade-titulo strong {
                    display: block;
                }

                .formulario-documento .qualidade-meta {
                    table-layout: fixed;
                    margin-bottom: 18px;
                }

                .formulario-documento .qualidade-meta th,
                .formulario-documento .qualidade-meta td {
                    padding: 3px 6px;
                    vertical-align: middle;
                }

                .formulario-documento .qualidade-meta th:first-child,
                .formulario-documento .qualidade-meta td:first-child {
                    width: 58%;
                }

                .formulario-documento .qualidade-meta th:not(:first-child),
                .formulario-documento .qualidade-meta td:not(:first-child) {
                    text-align: center;
                }

                .secao-form {
                    margin: 14px 0 0;
                    padding: 6px 9px;
                    color: #fff;
                    background: #223f6b;
                    border: 1px solid #152b4d;
                    font-size: 11px;
                    line-height: 1.1;
                    font-weight: 700;
                    letter-spacing: 0.15px;
                    break-after: avoid;
                    page-break-after: avoid;
                }

                .formulario-documento .linha-campos {
                    gap: 0;
                    margin: 0;
                    align-items: stretch;
                    border-left: 1px solid #222;
                    border-bottom: 1px solid #222;
                }

                .formulario-documento .campo-linha {
                    display: block;
                    min-height: 31px;
                    padding: 5px 7px 4px;
                    border-right: 1px solid #222;
                }

                .formulario-documento .campo-linha span {
                    display: block;
                    margin-bottom: 1px;
                    color: #4b4b4b;
                    font-size: 7.5px;
                    line-height: 1.05;
                    text-transform: uppercase;
                    white-space: normal;
                }

                .formulario-documento .campo-linha strong {
                    display: block;
                    min-height: 11px;
                    border: 0;
                    font-size: 9.5px;
                    line-height: 1.15;
                }

                .formulario-documento .campo-assinatura {
                    min-height: 36px;
                    margin: 0;
                    padding: 5px 7px 4px;
                    border-right: 1px solid #222;
                    border-bottom: 0;
                }

                .formulario-documento .texto-termo {
                    margin: 8px 0;
                    font-size: 9px;
                    line-height: 1.35;
                }

                .formulario-documento .subtitulo-form {
                    margin: 12px 0 0;
                    padding: 5px 8px;
                    color: #fff;
                    background: #223f6b;
                    border: 1px solid #152b4d;
                    font-size: 9.5px;
                    break-after: avoid;
                    page-break-after: avoid;
                }

                .formulario-documento .box {
                    width: 9px;
                    height: 9px;
                    margin-left: 7px;
                }

                .formulario-documento .quebra-pagina {
                    break-before: page;
                    page-break-before: always;
                    margin-top: 0;
                }
            `;
    },
    getMensagemErro(error, fallback) {
      if (error && error.response && error.response.data) {
        if (typeof error.response.data === "string") {
          return error.response.data;
        }

        if (error.response.data.message) {
          return error.response.data.message;
        }
      }

      return fallback;
    },
  },
};
</script>

<style scoped>
.documentacao-servico-funerario {
  width: 100%;
}

.pagina-documentacao {
  min-height: 100%;
  padding: 16px;
  background-color: var(--app-bg);
}

@media (min-width: 640px) {
  .pagina-documentacao {
    padding: 24px;
  }
}

.filtros-documentacao-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 200px)) auto;
  align-items: start;
  justify-content: start;
  gap: 12px;
}

.filtros-documentacao-botao {
  margin-top: 22px;
}

@media (max-width: 599px) {
  .filtros-documentacao-grid {
    grid-template-columns: 1fr;
  }

  .filtros-documentacao-botao {
    margin-top: 0;
  }
}

.tabela-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 20px 0 12px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
}

.tabela-resumo {
  font-size: 0.8125rem;
  color: #64748b;
}

.tabela-busca {
  width: 280px;
  max-width: 100%;
  flex: 0 0 auto;
}

.coluna-botao-filtro {
  padding-bottom: 0;
}

.botao-filtro {
  min-height: 40px;
}
.resumo-atendimento {
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.resumo-secao-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e293b;
}

.resumo-secao-titulo .pi {
  color: #6366f1;
}

.resumo-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 16px;
}

.resumo-grid__largo {
  grid-column: span 2;
}

@media (max-width: 599px) {
  .resumo-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.resumo-label {
  margin-bottom: 2px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
}

.resumo-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e293b;
}

.destaque {
  font-size: 0.9375rem;
}

.documentos-titulo {
  margin-bottom: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e293b;
}

.min-width-0 {
  min-width: 0;
}

.documento-opcao {
  height: 100%;
  border-color: #dfe7ef !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.documento-opcao:hover {
  border-color: #4782b4 !important;
  box-shadow: 0 4px 14px rgba(71, 130, 180, 0.08);
}

.area-impressao {
  display: none;
}
.resumo-card {
  background: #fafafa;
  transition: 0.2s;
}

.resumo-card:hover {
  background: #f5f5f5;
}

.resumo-titulo {
  font-size: 0.75rem;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.resumo-conteudo {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.documento-card {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s;
}

.documento-card:hover {
  border-color: #a5b4fc;
  background: #f8fafc;
}

.documento-card--ativo,
.documento-card--ativo:hover {
  border-color: #6366f1;
  background: #eef2ff;
}

.documento-nome {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e293b;
}

.documento-descricao {
  margin-top: 2px;
  font-size: 0.75rem;
  color: #64748b;
}
.caption {
  line-height: 1.3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.checklist-impressao {
  margin: 0;
  padding-left: 18px;
}

.total-geral {
  margin-top: 16px;
  text-align: right;
}

@media print {
  body > *:not(.area-impressao) {
    display: none !important;
  }

  .area-impressao {
    display: block !important;
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    background: white !important;
  }

  .documento {
    padding: 20mm !important;
    font-family: Arial, sans-serif !important;
    color: #000 !important;
    background: white !important;
  }

  .cabecalho-impressao {
    border-bottom: 2px solid #333 !important;
    padding-bottom: 15px !important;
    margin-bottom: 20px !important;
  }

  .cabecalho-impressao h2 {
    margin: 0 0 10px 0 !important;
    font-size: 18px !important;
  }

  .cabecalho-impressao p {
    margin: 5px 0 !important;
    font-size: 12px !important;
  }

  .conteudo-impressao {
    font-size: 12px !important;
  }

  .conteudo-impressao h3 {
    margin: 15px 0 10px 0 !important;
    font-size: 14px !important;
    border-bottom: 1px solid #ccc !important;
    padding-bottom: 5px !important;
  }

  .conteudo-impressao p {
    margin: 5px 0 !important;
  }

  .tabela-impressao {
    width: 100% !important;
    border-collapse: collapse !important;
    margin: 10px 0 !important;
  }

  .tabela-impressao th,
  .tabela-impressao td {
    border: 1px solid #ddd !important;
    padding: 8px !important;
    text-align: left !important;
    font-size: 12px !important;
  }

  .tabela-impressao th {
    background-color: #f2f2f2 !important;
    font-weight: bold !important;
  }

  @page {
    margin: 20mm;
  }
}
</style>
